import { getDiscipline } from "@/lib/trainingDisciplines";
import { Badge } from "@/components/ui/badge";

export default function DisciplineBadge({ discipline, size = "default", className = "" }) {
  const d = getDiscipline(discipline);
  const Icon = d.icon;
  const sm = size === "sm";

  return (
    <Badge
      className={`gap-1.5 font-medium border-0 ${d.color} ${sm ? "text-[10px] px-2 py-0" : "text-xs"} ${className}`}
    >
      <Icon className={sm ? "w-3 h-3" : "w-3.5 h-3.5"} />
      {sm ? d.shortLabel : d.label}
    </Badge>
  );
}